<template>
  <div v-if="clientBundle && clientBundle.gFields != null">
    <pre>{{ clientBundle.logonData.UserName }}</pre>
    <div class="mb-3">
      <div class="accordion" id="accordion-2">
        <div class="card-header mb-3 sticky-top searchbar" sticky>
          <div class="row">
            <div class="col">
              <div class="row justify-content-start m-2">
                <b-form-group
                  v-if="clientBundle && clientBundle.serverType === 'both'"
                  label="Running report on"
                >
                  <b-form-radio-group
                    @change="resetSearchOptionsByFilterType()"
                    id="report-type"
                    v-model="searchOptions.reportType"
                    :options="reportOptions"
                    name="report-type-selector"
                  ></b-form-radio-group>
                </b-form-group>
              </div>
            </div>
            <div class="col">
              <div class="row justify-content-md-center">
                <b-button
                  squared
                  class="btn btn-secondary"
                  variant="info"
                  href="#"
                  id="dropdownMenuLink"
                  @click="show.searchPanel = !show.searchPanel"
                  data-toggle="collapse"
                  data-target="#search-body"
                >
                  {{
                    searchOptions.searchTitle &&
                    searchOptions.searchTitle.length > 0
                      ? `Saved Search: ${searchOptions.searchTitle}`
                      : "Search Options"
                  }}&nbsp;
                  <b-iconstack
                    font-scale="1"
                    :rotate="!show.searchPanel ? '180' : ''"
                  >
                    <b-icon stacked icon="chevron-down" scale="0.75"></b-icon>
                    <b-icon stacked icon="circle"></b-icon>
                  </b-iconstack>
                </b-button>
              </div>
              <div class="row justify-content-md-center">
                <button
                  class="mt-1 btn btn-link"
                  size="sm"
                  @click="resetSearchOptionsByFilterType()"
                >
                  {{
                    searchOptions.searchTitle !== ""
                      ? "Clear saved search"
                      : "Clear search settings"
                  }}
                </button>
              </div>
            </div>
            <div class="col">
              <div class="row justify-content-end" id="run-report-button">
                <b-button
                  squared
                  :disabled="
                    compiledSearchOptionsArray.length === 0 ||
                    !searchOptionsCheck.go
                  "
                  variant="success"
                  class="m-2"
                  @click="updateParent('runSearch')"
                >
                  <b-spinner
                    class="mb-1"
                    type="grow"
                    v-if="runSearchButtonDirty"
                    small
                  ></b-spinner>
                  &nbsp;Generate Report
                </b-button>
                <b-popover
                  target="run-report-button"
                  :triggers="
                    searchOptionsCheck.missing.length > 0 ||
                    searchOptionsCheck.msg.length > 0
                      ? 'hover'
                      : ''
                  "
                  placement="bottomleft"
                >
                  <template #title
                    ><b-icon-exclamation-circle-fill
                      v-show="!searchOptionsCheck.go"
                      class="mr-2"
                    ></b-icon-exclamation-circle-fill
                    >&nbsp;Check those settings</template
                  >
                  <ul
                    v-if="
                      searchOptionsCheck.msg.length > 1 ||
                      (searchOptionsCheck.missing.length > 0 &&
                        searchOptionsCheck.msg.length > 0)
                    "
                  >
                    <li v-for="m in searchOptionsCheck.msg" v-bind:key="m">
                      {{ m }}
                    </li>
                  </ul>
                  <span v-else-if="searchOptionsCheck.msg.length === 1">{{
                    searchOptionsCheck.msg[0]
                  }}</span>
                  <span v-if="searchOptionsCheck.missing.length > 0"
                    >Fields missing search values will be ignored, provide
                    values for these fields to ensure they are included in the
                    report:
                    <ul>
                      <li
                        v-for="f in searchOptionsCheck.missing"
                        v-bind:key="f"
                      >
                        {{ f }}
                      </li>
                    </ul>
                  </span>
                </b-popover>
              </div>
              <div class="row justify-content-end">
                <b-button
                  squared
                  class="p-0 m-2"
                  @submit.stop.prevent
                  @click="reloadAvailableSavedSearchesList()"
                >
                  <b-dropdown
                    id="dropdown-form"
                    text="Saved reports"
                    offset="-240"
                    v-on:keyup.space.prevent
                    lazy
                  >
                    <b-dropdown-form
                      v-on:keyup.space.prevent
                      id="saved-searches-bdform"
                    >
                      <b-form-group
                        id="saved-searches-bdform-group"
                        label="Saved reports"
                        label-for="load-search-form-dropdown"
                        @submit.stop.prevent
                      >
                        <b-form-select
                          style="width: 300px"
                          id="load-search-form-dropdown"
                          v-model="selectedSavedSearch"
                          class="mb-3"
                          @change="
                            selectedSearchChangeHandler(selectedSavedSearch)
                          "
                          value-field="name"
                          text-field="name"
                          disabled-field="notEnabled"
                        >
                          <b-form-select-option :value="null" disabled
                            >-- Sample searches --</b-form-select-option
                          >
                          <b-form-select-option
                            :value="presetSavedSearches('myweek')"
                            >My activity this week</b-form-select-option
                          >
                          <b-form-select-option
                            :value="presetSavedSearches('weekrundowns')"
                            >This week's rundowns</b-form-select-option
                          >
                          <b-form-select-option :value="null" disabled
                            >-- Saved searches --</b-form-select-option
                          >
                          <b-form-select-option
                            v-for="(search, index) in [
                              ...Object.values(savedSearchOptions),
                              // ...Object.values(availableSavedSearchesList()),
                            ]"
                            v-bind:key="index"
                            :value="search"
                            >{{ search.searchTitle }}</b-form-select-option
                          >
                        </b-form-select>
                        <b-row class="p-2">
                          <code>{{ searchPhrase }}</code>
                        </b-row>
                        <div class="row">
                          <b-button
                            squared
                            v-show="!searchOptions.isPreset"
                            class="m-1 col"
                            :disabled="
                              !searchOptions.searchTitle ||
                              selectedSavedSearch === null ||
                              searchOptions.isPreset
                            "
                            variant="success"
                            size="sm"
                            @click="updateParent('saveSearch')"
                            >Save
                            {{
                              selectedSavedSearch != null &&
                              selectedSavedSearch.searchTitle != null
                                ? selectedSavedSearch.searchTitle
                                : ""
                            }}</b-button
                          >
                          <b-button-group
                            class="m-1 col"
                            v-show="!searchOptions.isPreset"
                          >
                            <b-button
                              squared
                              :disabled="
                                !searchOptions.searchTitle ||
                                selectedSavedSearch === null ||
                                searchOptions.isPreset
                              "
                              variant="danger"
                              size="sm"
                              @click="
                                if (deleteButtonDirty) {
                                  updateParent('deleteSearch');
                                }
                                deleteButtonDirty = !deleteButtonDirty;
                              "
                            >
                              {{
                                deleteButtonDirty ? "Really Delete?" : "Delete"
                              }}</b-button
                            >
                            <b-button
                              squared
                              v-if="deleteButtonDirty"
                              :disabled="!searchOptions.searchTitle"
                              variant="danger"
                              size="sm"
                              @click="deleteButtonDirty = false"
                              >keep</b-button
                            >
                          </b-button-group>
                        </div>
                      </b-form-group>
                      <div
                        v-if="
                          clientBundle.savedSearches.list &&
                          Object.keys(clientBundle.savedSearches.list)
                            .length === 0
                        "
                      >
                        no saved reports found
                      </div>
                      <b-dropdown-divider></b-dropdown-divider>
                      <b-form-group
                        label="Save new report"
                        label-for="save-search-form-dropdown"
                        @submit.stop.prevent
                      >
                        <b-form-input
                          v-on:keyup.enter.prevent
                          v-on:keyup.space.prevent
                          id="save-search-form-dropdown"
                          size="sm"
                          placeholder="my new report"
                          v-model="newSavedSearchName"
                        ></b-form-input>
                        <input type="text" hidden />
                      </b-form-group>
                      <b-button
                        squared
                        :disabled="newSavedSearchName === ''"
                        variant="success"
                        size="sm"
                        @click="
                          searchOptions.searchId = null;
                          searchOptions.searchTitle = newSavedSearchName;
                          updateParent('saveSearchNew');
                          newSavedSearchName = '';
                        "
                        >Save New</b-button
                      >
                    </b-dropdown-form>
                  </b-dropdown>
                </b-button>
              </div>

              <div class="row justify-content-end">
                <b-link
                  class="mr-3"
                  v-show="runSearchButtonDirty === false"
                  href="#reporter-results"
                  @click="runSearchButtonDirty = null"
                  >{{ searchResultCount > 0 ? "scroll to" : "" }}
                  {{ searchResultCount }} results</b-link
                >
                <div
                  v-for="(searchObj, index) in compiledSearchOptionsArray"
                  v-bind:key="index"
                >
                  <b-link
                    :id="'copy-link' + index"
                    class="mr-3"
                    v-show="runSearchButtonDirty === false"
                    href=""
                    @click="copyJSONSearchPayload(index)"
                    >&#128203;</b-link
                  >
                  <b-popover
                    variant="warning"
                    :target="'copy-link' + index"
                    triggers="hover"
                    placement="top"
                  >
                    Copy JSON payload to run this search against the database
                    "{{
                      clientBundle.gTables._Servers.filter(
                        (y) => y.ServerID === searchObj.database.toUpperCase()
                      )[0].Description
                    }}"
                  </b-popover>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="card-body mb-3 collapse show"
          data-parent="#accordion-2"
          id="search-body"
        >
          <b-card v-if="searchOptions.reportType === 'ENPS'" class="mb-2">
            <template #header>
              <h4 class="">Date and location filters for ENPS content</h4>
            </template>

            <div class="row container">
              <div class="input-group">
                <div class="col">
                  <div class="input-group-prepend mb-3">
                    <span class="input-group-text">Dates</span>
                    <!--#ca9595-->
                    <ul class="list-group">
                      <li
                        class="list-group-item input-group"
                        v-for="range in ['all', 'custom']"
                        v-bind:key="range"
                      >
                        <input
                          name="date"
                          type="radio"
                          v-model="searchOptions.searchDate.selected"
                          :value="range"
                        />
                        {{ range[0].toUpperCase() + range.substring(1) }} Dates
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="col">
                  <b-overlay
                    class="mb-3"
                    :show="searchOptions.searchDate.selected === 'all'"
                    blur="2px"
                  >
                    <template #overlay>
                      <div class="d-flex align-items-center"></div>
                    </template>
                    <div class="input-group ml-5 pt-4">
                      <p>
                        <b-link
                          :style="ENPSContentDateClassLabel('today')"
                          @click="setENPSContentDateRange('today')"
                          >today</b-link
                        ><br />
                        <b-link
                          :style="ENPSContentDateClassLabel('week')"
                          @click="setENPSContentDateRange('week')"
                          class="ml-3"
                          >this week</b-link
                        ><br />
                        <b-link
                          :style="ENPSContentDateClassLabel('month')"
                          @click="setENPSContentDateRange('month')"
                          class="ml-3"
                          >this month</b-link
                        ><br /><b-link
                          :style="ENPSContentDateClassLabel('lastweek')"
                          @click="setENPSContentDateRange('lastweek')"
                          class="ml-3"
                          >last week</b-link
                        ><br />
                        <b-link
                          :style="ENPSContentDateClassLabel('lastmonth')"
                          @click="setENPSContentDateRange('lastmonth')"
                          class="ml-3"
                          >last month</b-link
                        >
                      </p>
                    </div>
                  </b-overlay>
                </div>

                <b-overlay
                  class="mb-3"
                  :show="searchOptions.searchDate.selected === 'all'"
                  blur="2px"
                >
                  <template #overlay>
                    <div class="d-flex align-items-center"></div>
                  </template>
                  <div class="col">
                    <div class="mb-3">
                      from:
                      <b-form-input
                        type="date"
                        class="form-control"
                        v-model.lazy="searchOptions.ItemDateFrom"
                        @change="searchOptions.searchDate.custom = ''"
                      >
                      </b-form-input>

                      to:
                      <b-form-input
                        type="date"
                        class="form-control"
                        v-model.lazy="searchOptions.ItemDateTo"
                        @change="searchOptions.searchDate.custom = ''"
                      >
                      </b-form-input>
                    </div>
                  </div>
                </b-overlay>
              </div>
            </div>

            <!--                -->
            <div v-if="searchOptions.reportType === 'ENPS'">
              <div
                class="card-header input-group-text"
                style="word-wrap: break-word"
              >
                <button
                  class="btn btn-link"
                  type="button"
                  data-toggle="collapse"
                  data-target="#content-locations"
                  aria-expanded="true"
                  aria-controls="content-collapse"
                >
                  Locations
                </button>

                <div class="row no-gutters">
                  <div
                    v-for="(group, index) in searchOptions.selectedGroups"
                    v-bind:key="group"
                    class="program-badge col m-1"
                  >
                    <b-badge
                      class="p-2"
                      v-if="clientBundle.gTables"
                      variant="success"
                      >{{ groupLabel(group) }}&nbsp;<b-link
                        class="program-badge-x"
                        @click="searchOptions.selectedGroups.splice(index, 1)"
                        >x</b-link
                      >
                    </b-badge>
                  </div>
                </div>
              </div>
              <div id="content-locations" class="container">
                <b-card-group deck>
                  <b-card no-body class="">
                    <template #header>
                      <h4 class="mb-0">Available Servers</h4>
                    </template>

                    <b-list-group flush style="overflow-y: auto">
                      <b-list-group-item
                        class="
                          input-group-prepend-sm
                          d-flex
                          justify-content-between
                          align-items-center
                        "
                        button
                        v-for="server in availableDatabases"
                        :key="server"
                        :variant="
                          searchOptions.selectedServer === server
                            ? 'success'
                            : ''
                        "
                        name="server-checkbox"
                        :value="server"
                        @click="searchOptions.selectedServer = server"
                      >
                        {{ serversLabel(server) }}
                        <b-badge
                          v-show="countGroupsByServer(server)"
                          variant="success"
                          pill
                          >{{ countGroupsByServer(server) }}</b-badge
                        >
                      </b-list-group-item>
                    </b-list-group>
                    <b-card-footer>
                      <b-row>
                        <b-col> </b-col>

                        <b-col> </b-col>
                      </b-row>
                    </b-card-footer>
                  </b-card>
                  <b-card no-body class="location-card">
                    <template #header>
                      <h4 class="mb-0">Available Folders</h4>
                    </template>
                    <b-list-group flush style="overflow-y: auto">
                      <b-list-group-item
                        button
                        class="input-group-prepend-sm"
                        v-for="group in availablePrograms"
                        :key="group"
                        :variant="
                          searchOptions.selectedGroups.includes(group)
                            ? 'success'
                            : ''
                        "
                        :value="group"
                        name="program-checkbox"
                        @click="
                          if (!searchOptions.selectedGroups.includes(group)) {
                            searchOptions.selectedGroups.push(group);
                          } else {
                            searchOptions.selectedGroups =
                              searchOptions.selectedGroups.filter(
                                (y) => y !== group
                              );
                          }
                        "
                      >
                        <span
                          :style="
                            searchOptions.selectedGroups.includes(group)
                              ? 'font-weight: 900'
                              : ''
                          "
                          class="float-left ml-2"
                        >
                          {{ groupLabel(group, false) }}
                        </span>
                      </b-list-group-item>
                    </b-list-group>

                    <b-card-footer>
                      <b-row v-show="searchOptions.selectedServer.length > 0">
                        <b-col>
                          <b-link
                            @click="
                              searchOptions.selectedGroups =
                                searchOptions.selectedGroups.filter(
                                  (y) => !availablePrograms.includes(y)
                                )
                            "
                            >Clear All</b-link
                          >
                        </b-col>

                        <b-col>
                          <b-link
                            @click="
                              searchOptions.selectedGroups = Array.from(
                                new Set([
                                  ...searchOptions.selectedGroups,
                                  ...availablePrograms,
                                ])
                              )
                            "
                            >Select All</b-link
                          >
                        </b-col>
                      </b-row>
                    </b-card-footer>
                  </b-card>
                </b-card-group>
                <!-- </b-form-row> -->
              </div>
            </div>
          </b-card>
          <!-- content types -->
          <b-card class="mb-2">
            <template #header>
              <h4>
                {{
                  searchOptions.reportType === "Playbook"
                    ? "Storytelling"
                    : "ENPS"
                }}
                records to return
              </h4>
            </template>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1"
                  >Maximum Records to return
                  {{
                    searchOptions.reportType === "ENPS" ? " per server" : ""
                  }}</span
                >
              </div>
              <input
                type="number"
                id="max-recs"
                class="form-control"
                v-model="searchOptions.maxRecords"
                name="maxrecords"
                autocomplete="on"
              />
            </div>

            <div
              v-for="filterType in ['Required', 'Optional']"
              v-bind:key="filterType"
            >
              <b-row class="card-header">
                <h4>{{ filterType }} Report Filters</h4>
                <p style="text-align: left" class="p-1 ml-2">
                  <code
                    >{{
                      show.briefingTell[filterType]
                        ? tell.briefing[filterType]
                        : tell.briefing[filterType].split(".")[0]
                    }}
                  </code>
                  <b-link
                    @click="
                      show.briefingTell[filterType] =
                        !show.briefingTell[filterType]
                    "
                    >{{ !show.briefingTell[filterType] ? "more" : "hide" }}
                  </b-link>
                </p>
              </b-row>
              <div
                class="card-header input-group-text"
                style="word-wrap: break-word"
              >
                <div
                  class="row"
                  v-b-popover.hover.ds1500.dh200.rightbottom="
                    `Add a${
                      filterType === 'Required' ? '' : 'n'
                    } *${filterType} Field* to your search.   ${tell.briefingPopover(
                      filterType
                    )}`
                  "
                >
                  <multiselect
                    class="fieldselect ml-3"
                    :id="`multi-${filterType}`"
                    @select="loadBriefingField"
                    @remove="unloadBriefingField"
                    multiple
                    :maxHeight="300"
                    open-direction="bottom"
                    :options="availableBriefingFields[filterType]"
                    :close-on-select="true"
                    :clear-on-select="true"
                    :preserve-search="true"
                    :resetAfter="true"
                    :custom-label="fieldsToReturnLabel"
                    :placeholder="`Add ${filterType.toLowerCase()} field`"
                    track-by="ID"
                    label="DefaultCaption"
                    :preselect-first="false"
                  >
                    <template slot="selection" slot-scope="{ values, isOpen }"
                      ><span
                        class="multiselect__single"
                        v-if="[values.length, !isOpen].every((x) => x === true)"
                      >
                        {{ filterType.toLowerCase() }} field{{
                          values.length === 1 ? "" : "s"
                        }}</span
                      ></template
                    >
                  </multiselect>
                </div>
                <div class="row ml-3 no-gutters">
                  <div class="col mr-3"></div>
                  <!-- -->
                  <div class="row no-gutters">
                    <div class="program-badge col ml-1">
                      <b-badge
                        style="word-wrap: break-word"
                        class="ml-1 p-2"
                        id="content-type-badge"
                        v-if="searchOptions.NOMContentTypes"
                        v-show="
                          filterType === 'Required' &&
                          Object.values(searchOptions.NOMContentTypes).some(
                            (x) => x === true
                          )
                        "
                        variant="success"
                        >Content Type is
                        {{
                          nomContentTypeSelections().length > 2
                            ? `${[...nomContentTypeSelections().length]} types`
                            : [...nomContentTypeSelections()].join(" and ")
                        }}
                      </b-badge>
                      <b-popover
                        :target="`content-type-badge`"
                        placement="bottomleft"
                        v-if="[...nomContentTypeSelections()].length > 2"
                        triggers="hover"
                        :title="
                          filterType +
                          'Content Type' +
                          `${nomContentTypeSelections().length > 1 ? 's' : ''}`
                        "
                      >
                        <ul>
                          <li
                            v-for="v in nomContentTypeSelections()"
                            v-bind:key="v"
                          >
                            {{ v }}
                          </li>
                        </ul>
                      </b-popover>
                    </div>
                    <div
                      class="program-badge col"
                      v-for="(brief, index) in searchOptions.briefingFields[
                        filterType
                      ]"
                      v-bind:key="index"
                      v-show="
                        searchOptions.briefingFields[filterType] &&
                        (brief.fieldValue.toString().length > 0 ||
                          brief.addBlank)
                      "
                    >
                      <b-badge
                        class="program-badge ml-1 p-2"
                        variant="success"
                        :id="`${filterType}-${brief.fieldInfo.ID}-badge`"
                        >{{ brief.fieldInfo.DefaultCaption }}&nbsp;is&nbsp;{{
                          badgeName(brief)
                        }}&nbsp;<b-link
                          class="program-badge-x"
                          @click="unloadBriefingField(index, filterType)"
                          >x</b-link
                        >
                      </b-badge>
                      <b-popover
                        :target="`${filterType}-${brief.fieldInfo.ID}-badge`"
                        placement="bottomleft"
                        v-if="
                          Array.isArray(brief.fieldValue) &&
                          brief.fieldValue.length > 4
                        "
                        triggers="hover"
                        :title="
                          filterType +
                          ' &quot;' +
                          brief.fieldInfo.DefaultCaption +
                          '&quot; values'
                        "
                      >
                        <ul>
                          <li
                            v-for="v in brief.fieldValue"
                            v-bind:key="v.name ? v.name : v"
                          >
                            {{ v.name ? v.name : v }}
                          </li>
                        </ul>
                      </b-popover>
                    </div>
                  </div>
                </div>
              </div>
              <b-card
                no-body
                class="container mb-3"
                :id="`filter-field-${filterType.toLowerCase()}-body`"
              >
                <b-list-group
                  flush
                  class="row"
                  v-if="filterType === 'Required'"
                >
                  <b-list-group-item class="col">
                    <b-input-group
                      append="required field"
                      size="md"
                      style="
                        white-space: nowrap;
                        background-color: rgb(233, 236, 239);
                      "
                    >
                      <template #prepend>
                        <b-input-group-text>
                          {{
                            searchOptions.reportType === "Playbook"
                              ? "Storytelling"
                              : "ENPS"
                          }}
                          Content Type
                          <b-icon
                            v-show="
                              !Object.values(
                                searchOptions.NOMContentTypes
                              ).some((x) => x === true)
                            "
                            class="col ml-1"
                            icon="exclamation-circle-fill"
                            v-b-popover.hover.top="
                              'Choose at least one content type'
                            "
                          ></b-icon>
                        </b-input-group-text>
                      </template>
                      <b-input-group-prepend>
                        <b-button class="p-0" squared variant="success">
                          <b-dropdown
                            :variant="
                              Object.values(searchOptions.NOMContentTypes).some(
                                (x) => x === true
                              )
                                ? 'success'
                                : 'outline-success'
                            "
                            boundary="window"
                            no-flip
                            menu-class=""
                            class="lg"
                            dropup
                            :text="
                              'Select ' +
                              (searchOptions.reportType === 'Playbook'
                                ? 'Storytelling'
                                : 'ENPS') +
                              ' Content Types'
                            "
                          >
                            <b-dropdown-form
                              style="max-height: 210px; overflow-y: auto"
                              v-if="searchOptions.reportType === 'ENPS'"
                            >
                              <b-form-checkbox
                                v-for="(
                                  value, key
                                ) in searchOptions.NOMContentTypes"
                                :key="key"
                                v-model.lazy="
                                  searchOptions.NOMContentTypes[key]
                                "
                                :checked="value.selected"
                                :name="'content-type-' + key"
                                :id="'content-type-' + key"
                                v-show="disabledTypes.indexOf(key) === -1"
                                >{{ key.replace("Newsgathering", "Planning ") }}
                              </b-form-checkbox>
                            </b-dropdown-form>
                            <b-dropdown-form
                              style="max-height: 210px; overflow-y: auto"
                              v-else-if="
                                searchOptions.reportType === 'Playbook'
                              "
                            >
                              <b-form-checkbox
                                v-for="(
                                  value, key
                                ) in searchOptions.StorytellingTypes"
                                :key="key"
                                v-model.lazy="
                                  searchOptions.StorytellingTypes[key].selected
                                "
                                :checked="value.selected"
                                :name="'content-type-' + key"
                                :id="'content-type-' + key"
                                >{{ key }}
                              </b-form-checkbox>
                            </b-dropdown-form>
                          </b-dropdown>
                        </b-button>
                      </b-input-group-prepend>
                      <b-form-input
                        style="border-bottom-color: rgb(233, 236, 239)"
                        type="text"
                        disabled
                      ></b-form-input>
                    </b-input-group>
                  </b-list-group-item>
                </b-list-group>
                <b-list-group
                  flush
                  class="row"
                  v-for="(field, index) in searchOptions.briefingFields[
                    filterType
                  ]"
                  v-bind:key="field.fieldInfo.ID"
                >
                  <b-list-group-item class="col">
                    <b-input-group
                      size="md"
                      style="
                        white-space: nowrap;
                        background-color: rgb(233, 236, 239);
                      "
                    >
                      <b-input-group-prepend is-text>
                        <span>{{ field.fieldInfo.DefaultCaption }}</span>
                        &nbsp;
                        <b-icon
                          v-show="
                            field.fieldValue.toString() === '' &&
                            !field.addBlank
                          "
                          class="col ml-1"
                          icon="exclamation-circle-fill"
                          v-b-popover.hover.top="
                            'Missing or invalid query value'
                          "
                        ></b-icon>
                        <b-icon
                          v-show="
                            ['Time', 'Date'].includes(
                              field.fieldInfo.Validation
                            ) && checkFieldDateValues(field)
                          "
                          class="col ml-1"
                          icon="exclamation-circle-fill"
                          v-b-popover.hover.top="
                            `Invalid date range, start date '${field.fieldRangeStart}' occurs after the end date '${field.fieldRangeEnd}'`
                          "
                        ></b-icon>
                      </b-input-group-prepend>
                      <!-- IF FIELD IS Number/Duration -->
                      <b-form-input
                        type="number"
                        number
                        v-if="
                          ['Number', 'Duration'].includes(
                            field.fieldInfo.Validation
                          )
                        "
                        v-model="field.fieldRangeStart"
                        :placeholder="`Miniumum number ${
                          field.fieldInfo.Validation === 'Duration'
                            ? 'of seconds'
                            : ''
                        }`"
                        @input="handleNumberValues(field)"
                        min="0"
                        :max="field.fieldRangeEnd || 9999999"
                      ></b-form-input>
                      <b-input-group-prepend
                        v-show="
                          ['Number', 'Duration'].includes(
                            field.fieldInfo.Validation
                          )
                        "
                        is-text
                        ><span>to</span></b-input-group-prepend
                      >
                      <b-form-input
                        type="number"
                        number
                        v-if="
                          ['Number', 'Duration'].includes(
                            field.fieldInfo.Validation
                          )
                        "
                        :min="field.fieldRangeStart || 0"
                        max="9999999"
                        v-model="field.fieldRangeEnd"
                        :placeholder="`Max number ${
                          field.fieldInfo.Validation === 'Duration'
                            ? 'of seconds'
                            : ''
                        }`"
                        @input="handleNumberValues(field)"
                      ></b-form-input>
                      <!-- IF FIELD IS Text -->
                      <b-form-input
                        v-if="field.fieldInfo.Validation === 'Text'"
                        v-model="field.fieldValue"
                        :placeholder="`Enter text or * for any non-blank value`"
                        @input="
                          if (field.fieldValue === '*') field.addBlank = false;
                        "
                      ></b-form-input>
                      <b-input-group-append
                        is-text
                        v-if="['Text'].includes(field.fieldInfo.Validation)"
                      >
                        also include blank values &nbsp;
                        <b-form-checkbox
                          :disabled="field.fieldValue === '*'"
                          v-model="field.addBlank"
                          class="mr-2"
                          @change="
                            if (field.fieldValue === '*') field.fieldValue = '';
                          "
                          v-b-popover.hover.top="
                            field.fieldValue === '*' && field.addBlank != null
                              ? `Wildcard search '*' cannot also include blank values`
                              : ``
                          "
                        >
                        </b-form-checkbox>
                      </b-input-group-append>
                      <!-- IF FIELD IS Date or Time -->
                      <b-form-input
                        v-if="
                          ['Date', 'Time'].indexOf(field.fieldInfo.Validation) >
                          -1
                        "
                        type="date"
                        aria-label="start datetime"
                        v-model="field.fieldRangeStart"
                        @change="setBriefingDateRange(field)"
                      ></b-form-input>
                      <b-input-group-text
                        v-if="
                          ['Date', 'Time'].indexOf(field.fieldInfo.Validation) >
                          -1
                        "
                        >&nbsp;and&nbsp;</b-input-group-text
                      >
                      <b-form-input
                        v-if="
                          ['Date', 'Time'].indexOf(field.fieldInfo.Validation) >
                          -1
                        "
                        type="date"
                        aria-label="end datetime"
                        v-model="field.fieldRangeEnd"
                        @change="setBriefingDateRange(field)"
                      ></b-form-input>
                      <!-- if FIELD is CheckBox -->
                      <b-form-select
                        v-if="
                          field.fieldInfo.Validation.toLowerCase() ===
                          'checkbox'
                        "
                        v-model="field.fieldValue"
                      >
                        <b-form-select-option value="true"
                          >true</b-form-select-option
                        >
                        <b-form-select-option value="false"
                          >false</b-form-select-option
                        >
                      </b-form-select>
                      <b-input-group-prepend>
                        <!-- IF FIELD IS StaffIDList -->
                        <b-button
                          class="p-0"
                          squared
                          variant="success"
                          v-if="field.fieldInfo.Validation === 'StaffIDList'"
                        >
                          <b-dropdown
                            boundary="window"
                            variant="success"
                            @hide="activeFilterText = ''"
                            dropup
                            class="lg"
                            menu-class=""
                            :text="field.fieldInfo.DefaultCaption + ' options'"
                          >
                            <b-dropdown-form
                              style="max-height: 210px; overflow-y: auto"
                            >
                              <b-form-input
                                v-model="activeFilterText"
                                size="sm"
                                placeholder="filter"
                                type="search"
                              >
                              </b-form-input>
                              <b-link @click="field.fieldValue = []"
                                >clear selection{{
                                  field.fieldValue.length > 1 ? "s" : ""
                                }}</b-link
                              >
                              <b-form-checkbox
                                v-for="option in [
                                  {
                                    name: 'any value',
                                    ID: `${notBlankSearchKey}`,
                                  },
                                  { name: 'no value', ID: '@blank' },
                                  ...staffIDListValues(),
                                ]"
                                v-show="
                                  activeFilterText === '' ||
                                  option.name
                                    .toLowerCase()
                                    .indexOf(activeFilterText.toLowerCase()) >
                                    -1
                                "
                                @change="handleChecklistBlankToggle(field)"
                                v-model="field.fieldValue"
                                :key="option.ID"
                                :value="option"
                                :name="field.fieldInfo.ID + '-' + option"
                              >
                                {{
                                  activeFilterText === ""
                                    ? option.name
                                        .replace(notBlankSearchKey, "any value")
                                        .replace("@blank", "no value")
                                    : ""
                                }}<span>
                                  {{
                                    activeFilterText.length > 0
                                      ? splitCaptionOnFilterText(
                                          activeFilterText,
                                          option.name
                                        )[0]
                                      : ""
                                  }}<strong>{{
                                    activeFilterText.length > 0
                                      ? splitCaptionOnFilterText(
                                          activeFilterText,
                                          option.name
                                        )[1]
                                      : ""
                                  }}</strong
                                  >{{
                                    activeFilterText.length > 0
                                      ? splitCaptionOnFilterText(
                                          activeFilterText,
                                          option.name
                                        )[2]
                                      : ""
                                  }}</span
                                >
                              </b-form-checkbox>
                            </b-dropdown-form>
                          </b-dropdown>
                        </b-button>
                        <!-- IF FIELD IS CheckList or ComboBox-->
                        <b-button
                          class="p-0"
                          v-if="
                            ['CheckList', 'ComboBox'].indexOf(
                              field.fieldInfo.Validation
                            ) > -1
                          "
                          squared
                          variant="success"
                        >
                          <b-dropdown
                            variant="success"
                            boundary="window"
                            dropup
                            @hide="activeFilterText = ''"
                            class="lg"
                            menu-class=""
                            :text="field.fieldInfo.DefaultCaption + ' options'"
                          >
                            <b-dropdown-form
                              style="max-height: 210px; overflow-y: auto"
                            >
                              <b-form-input
                                v-model="activeFilterText"
                                size="sm"
                                placeholder="filter"
                                type="search"
                              >
                              </b-form-input>
                              <b-link @click="field.fieldValue = []"
                                >clear selection{{
                                  field.fieldValue.length > 1 ? "s" : ""
                                }}</b-link
                              >
                              <b-form-checkbox
                                v-for="option in [
                                  ...comboCheckListValues(field),
                                ]"
                                v-show="
                                  activeFilterText === '' ||
                                  option
                                    .toLowerCase()
                                    .indexOf(activeFilterText.toLowerCase()) >
                                    -1
                                "
                                v-model="field.fieldValue"
                                :key="option"
                                :value="option"
                                :name="field.fieldInfo.ID + '-' + option"
                                @change="handleChecklistBlankToggle(field)"
                                >{{
                                  activeFilterText === ""
                                    ? option
                                        .replace(notBlankSearchKey, "any value")
                                        .replace("@blank", "no value")
                                    : ""
                                }}<span>
                                  {{
                                    activeFilterText.length > 0
                                      ? splitCaptionOnFilterText(
                                          activeFilterText,
                                          option
                                        )[0]
                                      : ""
                                  }}<strong>{{
                                    activeFilterText.length > 0
                                      ? splitCaptionOnFilterText(
                                          activeFilterText,
                                          option
                                        )[1]
                                      : ""
                                  }}</strong
                                  >{{
                                    activeFilterText.length > 0
                                      ? splitCaptionOnFilterText(
                                          activeFilterText,
                                          option
                                        )[2]
                                      : ""
                                  }}
                                </span>
                              </b-form-checkbox>
                            </b-dropdown-form>
                          </b-dropdown>
                        </b-button>
                        <!-- IF FIELD IS tree-->
                        <b-button
                          v-if="field.fieldInfo.Validation === 'Tree'"
                          class="p-0"
                          squared
                          variant="success"
                        >
                          <b-dropdown
                            variant="success"
                            boundary="window"
                            dropup
                            class="lg"
                            menu-class=""
                            :text="field.fieldInfo.DefaultCaption + ' options'"
                          >
                            <b-dropdown-form
                              style="max-height: 210px; overflow-y: auto"
                            >
                              <b-form-checkbox
                                v-for="option in [
                                  '@blank',
                                  ...unpackTreeValues(field.fieldInfo.ID),
                                ]"
                                v-model="field.fieldValue"
                                :key="option"
                                :value="option"
                                :name="field.fieldInfo.ID + '-' + option"
                                >{{ option.replace("@blank", "no value") }}
                              </b-form-checkbox>
                            </b-dropdown-form>
                          </b-dropdown>
                        </b-button>
                      </b-input-group-prepend>
                      <b-form-input
                        style="border-bottom-color: rgb(233, 236, 239)"
                        type="text"
                        disabled
                        v-if="
                          [
                            'Text',
                            'Number',
                            'Duration',
                            'Date',
                            'Time',
                            'Checkbox',
                          ].indexOf(field.fieldInfo.Validation) === -1
                        "
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          @click="unloadBriefingField(index, filterType)"
                          >X</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                    <div
                      v-if="
                        ['Date', 'Time'].indexOf(field.fieldInfo.Validation) >
                        -1
                      "
                    >
                      <b-link
                        @click="setBriefingDateRange(field, 'today')"
                        :style="briefingFieldDateClassLabel(field, 'today')"
                        >today</b-link
                      >&nbsp;
                      <b-link
                        @click="setBriefingDateRange(field, 'week')"
                        class="ml-3"
                        :style="briefingFieldDateClassLabel(field, 'week')"
                        >this week</b-link
                      >&nbsp;
                      <b-link
                        @click="setBriefingDateRange(field, 'month')"
                        class="ml-3"
                        :style="briefingFieldDateClassLabel(field, 'month')"
                        >this month</b-link
                      ><b-link
                        @click="setBriefingDateRange(field, 'lastweek')"
                        class="ml-3"
                        :style="briefingFieldDateClassLabel(field, 'lastweek')"
                        >last week</b-link
                      >&nbsp;
                      <b-link
                        @click="setBriefingDateRange(field, 'lastmonth')"
                        class="ml-3"
                        :style="briefingFieldDateClassLabel(field, 'lastmonth')"
                        >last month</b-link
                      >
                    </div>
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </div>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1"
                  >Search using keywords</span
                >
              </div>
              <input
                type="search"
                id="searchQuery"
                class="form-control"
                v-model="searchOptions.queryTerms"
                name="searchquery"
                placeholder="enter search keywords..."
                autocomplete="on"
              />
            </div>
          </b-card>

          <!-- fields to return -->
          <b-card>
            <template #header>
              <h4 style="text-align: left">Fields to return</h4>
              <p style="text-align: left" class="p-1 ml-2">
                <code
                  >{{
                    show.fieldsToReturn
                      ? tell.fieldsToReturn
                      : tell.fieldsToReturn.split(".")[0]
                  }}
                </code>
                <b-link @click="show.fieldsToReturn = !show.fieldsToReturn">{{
                  !show.fieldsToReturn ? "more" : "hide"
                }}</b-link>
              </p>
            </template>
            <div
              class="card-header input-group-text"
              style="word-wrap: break-word"
            >
              <div class="row">
                <div class="col-4 align-top">
                  <multiselect
                    class="align-top fieldselect"
                    style="width: 180px"
                    :options="availableReturnFields"
                    track-by="ID"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :reset-after="true"
                    :preserve-search="true"
                    @select="loadReturnField"
                    placeholder="Add Fields to Return"
                    label="DefaultCaption"
                    :custom-label="fieldsToReturnLabel"
                    :preselect-first="false"
                    :hideSelected="true"
                  >
                  </multiselect>
                  <div
                    class="row m-2"
                    v-show="searchOptions.fieldsToReturn.length > 0"
                  >
                    <button
                      class="btn btn-link"
                      type="button"
                      @click="searchOptions.fieldsToReturn = []"
                    >
                      Clear all
                    </button>
                  </div>
                </div>
              </div>
              <div class="ml-3 row no-gutters">
                <div
                  class="program-badge col m-1"
                  v-for="f in ['Title', 'Last Modified Time', 'Content Type']"
                  v-bind:key="f"
                  v-b-popover.hover.top="f + ' is a required field'"
                >
                  <b-badge class="program-badge p-2">{{ f }} </b-badge>
                </div>
                <div
                  v-for="(
                    fieldCaption, index
                  ) in searchOptions.fieldsToReturn.filter(
                    (x) => x.DefaultCaption
                  )"
                  v-bind:key="index"
                  class="program-badge col m-1"
                >
                  <b-badge
                    v-if="searchOptions.fieldsToReturn"
                    variant="success"
                    class="p-2"
                    >{{ fieldCaption.DefaultCaption }}&nbsp;<b-link
                      class="program-badge-x"
                      @click="searchOptions.fieldsToReturn.splice(index, 1)"
                      >x</b-link
                    >
                  </b-badge>
                </div>
              </div>
            </div>
            <div class="card-header input-group-text">
              <button
                class="btn btn-link"
                type="button"
                data-toggle="collapse"
                data-target="#reorder-fields"
                aria-expanded="true"
                aria-controls="fields-collapse"
              >
                Change field order
              </button>
            </div>
            <div
              id="reorder-fields"
              :class="`container ${
                !show.changeFieldOrder ? 'collapsed' : ''
              } collapse`"
              v-if="clientBundle.gFields"
            >
              <b-list-group>
                <b-list-group-item
                  class="d-flex align-items-center"
                  variant="info"
                  v-for="(x, i) in [
                    'Title',
                    'Last Modified time',
                    'Content Type',
                  ]"
                  v-bind:key="x"
                >
                  <div class="col-3">
                    <b-badge class="float-left">required</b-badge>
                  </div>
                  <span class="pr-2">{{ i + 1 }}</span>
                  <span class="pl-2">{{ x }}</span>
                </b-list-group-item>
                <b-list-group-item
                  v-for="(field, index) in searchOptions.fieldsToReturn"
                  v-bind:key="field.ID"
                  class="d-flex align-items-center"
                  v-bind:class="{
                    fieldlist: (index / 2).toString().indexOf('.') !== -1,
                  }"
                >
                  <div class="col-3">
                    <b-button
                      squared
                      class="float-left ml-1"
                      :disabled="index === 0"
                      variant="outline-primary"
                      v-on:click="reorder(index)"
                      ><b-icon
                        icon="chevron-down"
                        rotate="180"
                        scale="1"
                        variant="danger"
                      ></b-icon> </b-button
                    ><b-button
                      squared
                      class="float-left ml-1"
                      :disabled="
                        index === searchOptions.fieldsToReturn.length - 1
                      "
                      variant="outline-info"
                      v-on:click="reorder(index, true)"
                    >
                      <b-icon
                        icon="chevron-down"
                        scale="1"
                        variant="danger"
                      ></b-icon
                    ></b-button>
                  </div>
                  <span class="pr-2">{{ index + 4 }}</span
                  >&nbsp;<span class="pl-2"> {{ field.DefaultCaption }}</span>

                  <!-- <div class="col-5 justify-content-start">
                  </div> -->
                </b-list-group-item>
              </b-list-group>
            </div>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "bootstrap";
import LZ from "lz-string";
// import FCheckBox from "@/vue-filtery-checkbox.vue";

const reverseENPSObjectDictionary = {
  UNASSIGNED: 0,
  WIRES: 1,
  RUNDOWNS: 2,
  SCRIPTS: 3,
  AUDIO: 4,
  VIDEO: 5,
  PICTURE: 6,
  READINS: 7,
  NEWSGATHERINGITEMS: 8,
  MESSAGE: 9,
  GRIDS: 10,
  CONTACTS: 11,
  NEWSGATHERINGGRIDS: 12,
  MOSOBJ: 13,
  ELECTION: 14,
  MOSOBJR: 15,
  OPENS: 16,
  ASSIGNMENT: 138,
  TOPIC: 137,
};

const templateReturnField = (id, caption, options = {}) => {
  return {
    ID: id,
    DefaultCaption: caption,
    Validation: options.Validation ? options.Validation : "Text",
    List: options.List ? options.List : "",
    Type: options.Type ? options.Type : "Script+RO Column",
    TopicProp: options.TopicProp ? options.TopicProp : false,
    AssignmentProp: options.AssignmentProp ? options.AssignmentProp : false,
  };
};
const defaultSearchOptions = (serverType = "ENPS") => {
  return {
    searchTitle: "",
    searchId: "",
    isPreset: false,
    reportType: serverType,
    fieldsToReturn: [],
    queryTerms: "",
    maxRecords: 500,
    ItemDateTo: "",
    ItemDateFrom: "",
    briefingFields: { Optional: [], Required: [] },
    selectedServers: [],
    selectedServer: "",
    selectedGroups: [],
    StorytellingTypes: {
      Assignments: { selected: false, type: 138 },
      Topics: { selected: true, type: 137 },
    },
    NOMContentTypes: {
      All: false,
      Audio: false,
      Contacts: false,
      Grids: false,
      Messages: false,
      NewsgatheringGrids: false,
      NewsgatheringItems: false,
      Pictures: false,
      Readins: false,
      Rundowns: false,
      Scripts: true,
      Storyboards: false,
      Video: false,
    },
    searchDate: { selected: "all", custom: "today" },
  };
};

export default {
  name: "SearchConfiguration",
  // components: { FCheckBox },
  props: {
    clientBundle: Object,
  },
  data() {
    return {
      tell: {
        fieldsToReturn:
          "Select the fields to be included in your report.  The fields Title, Last Modified Time and Content Type are automatically included in every report and can't be removed here. Once you've added some new fields to the list you can change the order by clicking the arrows in the \"Change field order\" section below.",
        dateAndLocation: {},
        briefingPopover: function (filterType) {
          return `Use the picker below to enter a ${filterType.toLowerCase()} field name and value to your report.  All returned records will meet ${
            filterType === "Optional" ? "at least one" : "all"
          } of the conditions as set below.\r\n ${
            filterType === "Optional"
              ? ""
              : "The filter for Content Type is there by default because you must specify at least one content type to create a report."
          }`;
        },
        briefing: {
          Optional:
            'Optional filters create an "OR" scenario in your report. To appear in the report, records must meet at least one of the Optional criteria plus ALL of the Required criteria.',
          Required:
            "Use the picker below to enter a required field name and value to your report.  All returned records will meet the conditions set below.\r\nThe filter for Content Type is there by default because you must specify at least one content type to create a report.",
        },
      },
      show: {
        searchPanel: true,
        briefingTell: { Required: false, Optional: false },
        fieldsToReturn: false,
        changeFieldOrder: true,
      },
      customReturnFields: [
        templateReturnField("parentDatabase", "Database"),
        templateReturnField("parentFolder", "Folder"),
        templateReturnField("parentCollection", "Parent", {
          TopicProp: true,
          AssignmentProp: true,
        }),
        templateReturnField("text", "Text"),
      ],
      savedSearchOptions: {},
      disabledReturnFields: ["ModTime"],
      disabledBriefingFields: ["Actual"],
      disabledTypes: [
        "All",
        "Audio",
        "Contacts",
        "Grids",
        "Messages",
        "Pictures",
        "Readins",
        "Storyboards",
        "Video",
      ],
      activeFilterText: "",
      runSearchButtonDirty: null,
      newSavedSearchName: "",
      searchResultCount: 0,
      deleteButtonDirty: false,
      selectedBriefingFields: { Required: [], Optional: [] },
      selectedSavedSearch: null,
      reportOptions: ["ENPS", "Storytelling"],
      searchOptions: defaultSearchOptions(),
    };
  },
  mounted: function () {
    let t = this;
    t.getLocalLZ();
    // this.searchOptions.reportType = this.clientBundle.serverType;
  },
  computed: {
    apiVersionNineThree: function () {
      let t = this;
      return (
        Number.parseFloat(t.clientBundle.logonData.ClientFileVersion) > 9.0
      );
    },
    notBlankSearchKey: function () {
      let t = this;
      return t.apiVersionNineThree ? `['' TO *]` : "*";
    },
    availableBriefingFields: function () {
      let t = this;

      let b = t.clientBundle.gFields.complete
        .filter(
          (x) =>
            x.Briefable &&
            x.Validation !== "Table" &&
            !t.disabledBriefingFields.includes(x.ID)
        )
        .filter(
          (x) =>
            [
              ...t.selectedBriefingFields.Required,
              ...t.selectedBriefingFields.Optional,
            ]
              .map((y) => y.ID)
              .indexOf(x.ID) === -1
        );
      b = t.filterFieldsByReportType(b, t.searchOptions.reportType);

      b = b
        .filter(
          (x) =>
            [
              ...t.searchOptions.briefingFields.Optional,
              ...t.searchOptions.briefingFields.Required,
            ]
              .map((y) => y.fieldInfo.ID)
              .indexOf(x.ID) === -1
        )
        .sort((aa, bb) =>
          `${aa.DefaultCaption || aa.ID}`.localeCompare(
            bb.DefaultCaption || bb.ID
          )
        );
      b = [...new Set([...b])];
      return {
        Required: b,
        Optional: b,
      };
    },
    searchOptionsCheck: function () {
      const t = this;
      const so = t.searchOptions;
      let report = [],
        canGo = true;
      let allFields = [
        ...so.briefingFields.Required,
        ...so.briefingFields.Optional,
      ];
      //missing field values
      let missingFieldValues = allFields
        .filter((x) => x.fieldValue.toString().length === 0 && !x.addBlank)
        .map((f) => f.fieldInfo.ID);
      //invalid date ranges
      allFields
        .filter((x) => ["Time", "Date"].includes(x.fieldInfo.Validation))
        .forEach((x) => {
          if (t.checkFieldDateValues(x)) {
            report.push(
              `Invalid date range '${x.fieldRangeEnd}' must occur after '${x.fieldRangeStart}'.`
            );
          }
        });
      //invalid number/duration ranges
      allFields
        .filter((x) => ["Number", "Duration"].includes(x.fieldInfo.Validation))
        .forEach((x) => {
          if (
            x.fieldValue.split("-")[1] < x.fieldValue.split("-")[0] ||
            (x.fieldRangeEnd < x.fieldRangeStart && x.fieldValue === "")
          ) {
            canGo = false;
            report.push(
              `Invalid ${x.fieldInfo.Validation.toLowerCase()} range '${
                x.fieldValue.split("-")[1] || x.fieldRangeEnd
              }' is lower than '${
                x.fieldValue.split("-")[0] || x.fieldRangeStart
              }'.`
            );
          }
        });

      //check max records is a valid number
      if (!Number.parseInt(so.maxRecords)) {
        canGo = false;
        report.push("Max records is not a valid number");
      }

      //if playbook check content types are not empty
      if (
        so.reportType === "Playbook" &&
        Object.values(so.StorytellingTypes).filter((y) => y.selected).length ===
          0
      ) {
        canGo = false;
        report.push(`No playbook content types are selected.`);
      }
      //if enps
      if (so.reportType === "ENPS") {
        //if content types are all empty
        if (Object.values(so.NOMContentTypes).filter((y) => y).length === 0) {
          canGo = false;
          report.push("No ENPS content types selected");
        }
        if (
          ["all", "custom"].indexOf(so.searchDate.selected) === -1 ||
          (so.searchDate.selected === "custom" &&
            !(Date.parse(so.ItemDateFrom) <= Date.parse(so.ItemDateTo)))
        ) {
          canGo = false;
          report.push(
            `Invalid date range ${so.ItemDateTo} must occur after ${so.ItemDateFrom}`
          );
        }
        if (so.selectedGroups.length < 1) {
          canGo = false;
          report.push(
            'No valid search locations were specified, check Locations and pick at least one option fro the "Available Folders" list'
          );
        }
      }

      return { go: canGo, msg: report, missing: missingFieldValues };
    },
    reportSettings: function () {
      const t = this.searchOptions;
      return {
        searchId: t.searchId,
        searchTitle: t.searchTitle,
        ItemDateTo: t.ItemDateTo,
        ItemDateFrom: t.ItemDateFrom,
        NOMContentTypes: t.NOMContentTypes,
        queryTerms: t.queryTerms,
        searchDate: t.searchDate,
        // reportType: t.reportType,
        selectedServers: t.selectedServers,
        selectedServer: t.selectedServer,
        selectedGroups: t.selectedGroups,
        fieldsToReturn: t.fieldsToReturn,
        maxRecords: t.maxRecords,
        briefingFields: t.briefingFields,
        StorytellingTypes: t.StorytellingTypes,
      };
    },
    availableReturnFields: function () {
      const t = this;
      //array of data.customReturnFields and all gfields minus data.disabledReturnFields
      let a = [
        ...t.customReturnFields,
        ...t.clientBundle.gFields.complete,
      ].filter((y) => t.disabledReturnFields.indexOf(y.ID) === -1);
      //filter array by reportType
      if (t.searchOptions.reportType === "ENPS") {
        a = a.filter((x) => ["System", "Extended"].indexOf(x.Type) === -1);
      } else if (t.searchOptions.reportType === "Playbook")
        a = a.filter((x) => x.AssignmentProp || x.TopicProp);
      //remove already selected return fields and soert by DefaultCaption, .map to just ID and Default Caption
      a = a
        .filter(
          (y) =>
            t.searchOptions.fieldsToReturn.map((x) => x.ID).indexOf(y.ID) == -1
        )
        .sort((a, b) =>
          `${a.DefaultCaption || a.ID}`.localeCompare(b.DefaultCaption || b.ID)
        )
        .map((x) => {
          return {
            ID: x.ID,
            DefaultCaption: x.DefaultCaption,
          };
        });
      return a;
    },
    // availableSavedSearchesList: function () {
    //   const t = this.$props.clientBundle;
    //   return { ...t.savedSearches.list };
    // },
    // availableSavedSearches: function () {
    //   const t = this;
    //   return t.clientBundle.savedSearches.list != null;
    // },
    availablePrograms: function () {
      const t = this;
      return (
        t.clientBundle.gTables._Groups
          // .filter((g) => t.searchOptions.selectedServers.indexOf(g.Server) > -1)
          .filter(
            (g) => [t.searchOptions.selectedServer].indexOf(g.Server) > -1
          )
          .map((x) => x.ID)
      );
    },
    compiledDatabases: function () {
      const t = this;
      let r = [];
      if (t.searchOptions && t.searchOptions.reportType === "ENPS") {
        r = t.clientBundle.gTables._Groups
          .filter((x) => t.searchOptions.selectedGroups.indexOf(x.ID) > -1)
          .map((x) => x.Server)
          .filter((v, i, a) => a.indexOf(v) === i);
      } else if (t.searchOptions.reportType === "Playbook") {
        r = t.clientBundle.gTables._Groups
          .filter((c) => c.PSTGroup)
          .map((c) => c.Server);
      }
      return r;
    },
    availableDatabases: function () {
      const t = this;
      return t.clientBundle.gTables._Groups
        .filter(
          (x) =>
            t.clientBundle.gTables._Servers
              .map((x) => x.ID)
              .indexOf(x.ServerID) > -1
        )
        .reduce((a, d) => {
          if (!a.includes(d["Server"])) {
            a.push(d["Server"]);
          }
          return a;
        }, []);
    },
    contentDates: function () {
      const t = this,
        v =
          t.searchOptions.reportType === "ENPS"
            ? t.searchOptions.searchDate.selected.toLowerCase() === "all"
            : true;
      return {
        All: v,
        CustomDateRange: !v,
        FortyEightHours: false,
        Future: false,
        ItemDateFrom: v
          ? "1800-02-28T22:00:00.000Z"
          : t.localZeroHour(t.searchOptions.ItemDateFrom || "1800-02-28"),
        ItemDateTo: v
          ? "1800-02-28T22:00:00.000Z"
          : t.localZeroHour(t.searchOptions.ItemDateTo || "1800-02-28", true),
        OneHour: false,
        OneWeek: false,
        TwentyFourHours: false,
        TwoHours: false,
      };
    },
    compiledBriefingfields: function () {
      const t = this;
      return [
        ...t.searchOptions.briefingFields.Required,
        ...t.searchOptions.briefingFields.Optional,
      ]
        .filter(
          (x) =>
            x.name ||
            Array.from(x.fieldValue).length > 0 ||
            x.addBlank ||
            Number.isInteger(x.fieldValue)
        )
        .map((x) => {
          //set [r0] to tag fieldnames for optional values
          let o =
            t.searchOptions.briefingFields.Optional.indexOf(x) > -1
              ? "[r0]"
              : "";
          //fix unvalued array arrays stored as ""
          if (
            x.fieldValue === "" &&
            ["CheckList", "ComboBox", "StaffIDList"].indexOf(
              x.fieldInfo.Validation
            ) > -1
          ) {
            x.fieldValue = [];
          }
          //Duration and Number Fields
          if (["Duration", "Number"].includes(x.fieldInfo.Validation)) {
            return {
              FieldName: `${x.fieldInfo.ID}__range__`,
              FieldValue: `${x.fieldValue.replace("-", ";")}`,
            };
          }
          //staff id
          else if (x.fieldInfo.Validation === "StaffIDList") {
            if (
              x.fieldValue.map((xx) => xx.ID).includes(`${t.notBlankSearchKey}`)
            ) {
              return {
                FieldName: `${x.fieldInfo.ID}__like__${o}`,
                FieldValue: `${t.notBlankSearchKey}`,
              };
            } else {
              return {
                FieldName: `${x.fieldInfo.ID}__list__${o}`,
                FieldValue:
                  `${x.fieldValue.map((y) => y.ID).join(";")};` +
                  x.fieldValue
                    .map((y) => `${x.fieldInfo.ID}.${y.ID}`)
                    .join(";"),
              };
            }
          } else if (["Date", "Time"].indexOf(x.fieldInfo.Validation) > -1)
            //date time range
            return {
              FieldName: `${x.fieldInfo.ID}__range__${o}`,
              FieldValue: x.fieldValue,
            };
          else if (
            x.fieldInfo.Validation == "CheckBox" &&
            x.fieldValue === "true"
          )
            //checkbox true
            return {
              FieldName: `${x.fieldInfo.ID}${o}`,
              FieldValue: "true",
            };
          else if (
            x.fieldInfo.Validation == "CheckBox" &&
            x.fieldValue === "false"
          )
            //checkbox false -checkbox blank no longer a thing
            return {
              FieldName: `-${x.fieldInfo.ID}${o}`,
              FieldValue: "true",
            };
          else if (Array.isArray(x.fieldValue)) {
            //checklist or combobox one or more selections

            return {
              FieldName: `${x.fieldInfo.ID}__list__${o}`,
              FieldValue: x.fieldValue.join(";"),
            };
          } else if (!Array.isArray(x.fieldValue) && !x.addBlank) {
            //text not array and not blank and value is *

            return x.fieldValue === "*"
              ? {
                  FieldName: `${x.fieldInfo.ID}__like__${o}`,
                  FieldValue: `${t.notBlankSearchKey}`,
                }
              : //text not array and not blank
                {
                  FieldName: `${x.fieldInfo.ID}__like__${o}`,
                  FieldValue: x.fieldValue,
                };
          } else if (!Array.isArray(x.fieldValue) && x.addBlank) {
            //text not array and also blank
            return [
              {
                FieldName: `${x.fieldInfo.ID}__like__[r0]`,
                FieldValue: x.fieldValue,
              },
              { FieldName: `${x.fieldInfo.ID}[r0]`, FieldValue: "@blank" },
            ];
          }
        })
        .flat();
    },
    pstTypeZfields: function () {
      const t = this;
      let a = Object.keys(t.searchOptions.StorytellingTypes)
        .map((x) => {
          return t.searchOptions.StorytellingTypes[x];
        })
        .filter((y) => y.selected)
        .map((x) => x.type);
      return t.searchOptions.reportType === "ENPS"
        ? [
            {
              FieldName: "type__list__",
              FieldValue: Object.keys(t.searchOptions.NOMContentTypes)
                .filter((y) => t.searchOptions.NOMContentTypes[y])
                .map((x) => {
                  return reverseENPSObjectDictionary[x.toUpperCase()];
                })
                .join(";"),
            },
          ]
        : [{ FieldName: "type__list__", FieldValue: a.join(";") }];
    },
    pstVirtualPathzField: function () {
      const t = this;
      let g = t.clientBundle.gTables._Groups.filter((x) => x.PSTGroup)[0];
      return t.searchOptions.reportType === "Playbook"
        ? [
            {
              FieldName: "virtualPath",
              FieldValue: `\\\\${g.Server}\\\\P_${g.ID}\\\\W\\\\PST`,
            },
          ]
        : [];
    },
    searchPhrase: function () {
      const t = this;
      let nomDates =
          t.searchOptions.reportType === "ENPS"
            ? `${
                t.searchOptions.searchDate.selected === "all"
                  ? " With no time or date restrictions"
                  : ` From between ${t.searchOptions.ItemDateFrom} and ${t.searchOptions.ItemDateTo}`
              }`
            : "",
        returnFieldList =
          `Showing the "Title", "Last Modified Time" and "Content Type" ${
            t.searchOptions.fieldsToReturn.length > 0 ? " plus: " : ""
          } ` +
          t.searchOptions.fieldsToReturn
            .map((x) => `"${x.DefaultCaption}"`)
            .join(" & "),
        contentTypeList = t.nomContentTypeSelections().join(" and "),
        groupsList = ` found in ${t.searchOptions.selectedGroups.join(
          " *and* "
        )}`,
        requiredList = t.searchOptions.briefingFields.Required.map(
          (x) =>
            ` "${x.fieldInfo.DefaultCaption} is ${
              t.badgeName(x, 10) /*
              Array.isArray(x.fieldValue)
                ? `(${x.fieldValue
                    .map(
                      (xx) => t.badgeName(xx)
                       `'${x.name || x}'`.replace(`['' TO *]`, "any value")
                    )
                    .join(" or ")})"`
                : t.badgeName(x)  `'${
                      ["Time", "Date"].includes(x.fieldInfo.Validation)
                        ? `between ${x.fieldRangeStart} and ${x.fieldRangeEnd}`
                        : `${(['Number','Duration'].includes(x.fieldInfo.Validation))? ``:x.fieldValue.replace(`['' TO *]`, "any value")}`
                    }'"` */
            }`
        ).join(" AND "),
        optionalList =
          `${
            t.searchOptions.briefingFields.Optional.length > 0 ? " OR " : ""
          }` +
          t.searchOptions.briefingFields.Optional.map(
            (x) =>
              `*${x.fieldInfo.DefaultCaption}* is ${
                t.badgeName(x, 10)
                /*  Array.isArray(x.fieldValue)
  ? `(${x.fieldValue
      .map(
        (xx) => t.badgeName(xx)
         `'${x.name || x}'`.replace(`['' TO *]`, "any value")
      )
      .join(" or ")})"`
  : t.badgeName(x) `'${
      ["Time", "Date"].includes(x.fieldInfo.Validation)
        ? `between ${x.fieldRangeStart} and ${x.fieldRangeEnd}`
        : `${(['Number','Duration'].includes(x.fieldInfo.Validation))? ``:x.fieldValue.replace(`['' TO *]`, "any value")}`
    }'"` */
              }`
          ).join(" OR ");
      return `${returnFieldList} from all ${contentTypeList}${groupsList}${
        t.searchOptions.briefingFields.Required.length > 0
          ? " where the following conditions apply:"
          : ""
      }${requiredList}${optionalList}.${nomDates}`;
    },
    compiledAdditionalReturnFields: function () {
      const t = this;
      const fieldIds = t.searchOptions.fieldsToReturn.map((x) => x.ID);
      let r = ["Title", "modTime", "virtualPath", "guid", "type"];
      if (fieldIds.some((r) => ["Segment", "Slug"].includes(r))) {
        r.push("type");
      }
      if (fieldIds.includes("Actual")) {
        r.push("TextTime", "MediaTime");
      }
      return r;
    },
    compiledCostSubFields: function () {
      const t = this;
      // const returnValue = [];
      // const CostFields = t.clientBundle.gFields.complete
      //   .filter((y) => y.Validation === "Cost")
      //   .map((x) => x.ID);
      const selectedCostFields = t.searchOptions.fieldsToReturn.filter((yy) =>
        t.clientBundle.gFields.complete
          .filter((y) => y.Validation === "Cost")
          .map((x) => x.ID)
          .includes(yy.ID)
      );

      return selectedCostFields.flatMap((cf) => {
        return t.clientBundle.gFields.complete
          .filter((y) => y.ID === cf.ID)[0]
          .List.split("|")
          .map((x) => {
            return {
              ID: cf.ID + "_" + x,
              DefaultCaption: cf.DefaultCaption + " [" + x + "]",
            };
          });
      });
    },
    compiledSearchOptionsArray: function () {
      const t = this;
      return t.compiledDatabases.map((server) => {
        return {
          database: server,
          NOMLocations:
            t.searchOptions.reportType === "ENPS"
              ? t.clientBundle.gTables._Groups
                  .filter(
                    (x) => t.searchOptions.selectedGroups.indexOf(x.ID) > -1
                  )
                  .filter((x) => x.Server === server)
                  .map((x) => x.ID)
                  .map((x) => {
                    return {
                      BasePath: `P_${x}\\`,
                      SearchWIP: true,
                      SearchArchives: true,
                      SearchTrash: false,
                    };
                  })
              : [
                  {
                    BasePath: `P_${
                      t.clientBundle.gTables._Groups.filter(
                        (x) => x.PSTGroup
                      )[0].ID
                    }\\`,
                    SearchWIP: true,
                    SearchArchives: true,
                    SearchTrash: false,
                  },
                ],
          NOMContentDates: t.contentDates,
          maxRecords: t.searchOptions.maxRecords,
          fieldsToReturnDict: [
            { ID: "Title", DefaultCaption: "Title" },
            { ID: "modTime", DefaultCaption: "Last Modified Time" },
            { ID: "type", DefaultCaption: "Content Type" },
            ...t.searchOptions.fieldsToReturn.filter(
              (yy) =>
                !t.clientBundle.gFields.complete
                  .filter((y) => y.Validation === "Cost")
                  .map((x) => x.ID)
                  .includes(yy.ID)
            ),
            ...t.compiledCostSubFields,
          ],
          fieldsToReturn: [
            ...t.searchOptions.fieldsToReturn.map((x) => x.ID),
            ...t.compiledAdditionalReturnFields,
          ].filter((v, i, a) => a.indexOf(v) === i),
          NOMContentTypes:
            t.searchOptions.reportType === "ENPS"
              ? t.searchOptions.NOMContentTypes
              : { ...t.searchOptions.NOMContentTypes, All: true },
          zFields: [
            ...t.pstVirtualPathzField,
            ...t.pstTypeZfields,
            ...t.compiledBriefingfields,
          ],
          queryTerms: t.searchOptions.queryTerms,
          searchPhrase: t.searchPhrase,
        };
      });
    },
  },

  watch: {
    searchOptions: () => {
      const t = this;
      if (t && t.searchOptions && t.searchOptions.searchTitle === "") {
        t.reloadAvailableSavedSearchesList();
        t.saveLocalLZ();
      }
    },
  },
  methods: {
    copyJSONSearchPayload(index = 0) {
      const t = this;
      navigator.clipboard.writeText(
        JSON.stringify(t.compiledSearchOptionsArray[index])
      );
    },
    reloadAvailableSavedSearchesList: function () {
      const t = this;
      t.savedSearchOptions = t.$props.clientBundle.savedSearches.list;
    },
    handleChecklistBlankToggle: function (field) {
      const t = this;
      //get index of notblank in staffID or checklist
      let isStaff = field.fieldValue[0] && !field.fieldValue[0].ID;
      let notblank = isStaff
        ? field.fieldValue.indexOf(`${t.notBlankSearchKey}`)
        : field.fieldValue.map((x) => x.ID).indexOf(`${t.notBlankSearchKey}`);
      //check notblank exists
      if (notblank > -1 && field.fieldValue.length > 1) {
        if (notblank > 0) {
          //notblank was added set array to only notblank
          field.fieldValue = isStaff
            ? [`${t.notBlankSearchKey}`]
            : [{ name: "any value", ID: `${t.notBlankSearchKey}` }];
        } else if (notblank === 0) {
          //something else was added, remove notblank
          field.fieldValue.splice(notblank, 1);
        }
      }
    },
    checkServerType: function () {
      const t = this;
      if (t.clientBundle && t.clientBundle.serverType) {
        return `${t.clientBundle.serverType}`.toLowerCase() === "both"
          ? "ENPS"
          : t.clientBundle.serverType;
      } else return "ENPS";
    },
    unpackTreeValues: function (fieldID) {
      const t = this;
      return t.clientBundle.gFields.complete
        .filter((x) => x.ID === fieldID)
        .map((y) => y.List)[0]
        .split("|")
        .map((x) => {
          return { [x.split("\\")[0]]: x.split("\\").slice(1) };
        })
        .map((x) => {
          return x[Object.keys(x)[0]].flatMap((y) => {
            return Object.keys(x)[0] + "-" + y;
          });
        })
        .filter((x) => x.length > 0)
        .flat();
    },
    comboCheckListValues: function (field) {
      const t = this;
      return [
        `${t.notBlankSearchKey}`,
        "@blank",
        ...field.fieldInfo.List.split("|"),
      ];
    },
    staffIDListValues: function () {
      return this.clientBundle.gTables._Staff.map((x) => {
        return {
          name: `${x.GivenName} ${x.Surname}`,
          ID: `${x.UserID}`,
        };
      });
    },
    filterFieldsByReportType: function (fieldArr, reportType) {
      const t = this;

      let ret = null;
      if (reportType === "ENPS") {
        ret = fieldArr.filter(
          (x) => ["System", "Extended"].indexOf(x.Type) === -1
        );
      } else if (reportType === "Playbook") {
        // if(t.searchOptions.StorytellingTypes.Assignments.selected)
        let fa = t.searchOptions.StorytellingTypes.Assignments.selected
          ? fieldArr.filter((x) => x.AssignmentProp)
          : [];
        let ft = t.searchOptions.StorytellingTypes.Topics.selected
          ? fieldArr.filter((x) => x.TopicProp)
          : [];
        // b = b.filter((x) => x.AssignmentProp || x.TopicProp);
        ret = [...fa, ...ft];
      }
      return ret;
    },
    availableBriefingStaffIDListFields: function () {
      const t = this;
      return t.filterFieldsByReportType(
        t.clientBundle.gFields.complete.filter(
          (x) => x.Briefable && x.Validation.toLowerCase() === "staffidlist"
        ),
        t.searchOptions.reportType
      );
    },
    presetSavedSearches: function (presetSearchTitle) {
      const t = this;
      let ret = {
        ...defaultSearchOptions(t.searchOptions.reportType),
        // selectedServers: [t.clientBundle.logonData.HomeDatabase],
        selectedServer: t.clientBundle.logonData.HomeDatabase,
        selectedGroups: [t.clientBundle.logonData.HomeProgram],
        isPreset: true,
        // reportType: t.searchOptions.reportType,
      };
      if (presetSearchTitle === "myweek") {
        //create preset search with staff ID fields optional set to logged in username
        ret.searchTitle = "My week";
        const staffListFieldsArr = t.availableBriefingStaffIDListFields();
        staffListFieldsArr.forEach((e) => {
          ret.briefingFields.Optional.push(
            t.newFilterFieldObject(e, [t.clientBundle.logonData.UserID])
          );
        });
        if (t.searchOptions.reportType === "ENPS") {
          //set enps content dates
          ret.searchDate.custom = "week";
          ret.ItemDateFrom = t.lastSunday();
          ret.ItemDateTo = t.nextSunday();
        } else if (t.searchOptions.reportType === "Playbook") {
          ret.briefingFields.Required.push(
            t.newFilterFieldObject(
              t.clientBundle.gFields.complete.filter(
                (x) => x.ID === "PSTTargetDate"
              )[0],
              "",
              "week"
            )
          );
        }
      } else if (presetSearchTitle === "weekrundowns") {
        ret.searchTitle = "This week's rundowns";
        ret.selectedGroups = t.clientBundle.gTables._Groups.map((x) => x.ID);
        ret.searchDate.custom = "week";
        ret.searchDate.selected = "custom";
        ret.ItemDateFrom = t.lastSunday();
        ret.ItemDateTo = t.nextSunday();
        ret.NOMContentTypes.Rundowns = true;
        ret.reportType = "ENPS";
      }

      return ret;
    },
    updateParent: function (updateType) {
      const t = this;
      if (updateType === "deleteSearch") {
        t.$emit("deleteSelectedSearch", t.selectedSavedSearch, function () {
          console.log("deleted saved search");
          t.selectedSavedSearch = null;
          t.searchOptions.searchTitle = "";
        });
      } else if (updateType === "saveSearch") {
        t.$emit("saveSearch", t.reportSettings);
      } else if (updateType === "saveSearchNew") {
        t.$emit("saveSearch", {
          ...t.reportSettings,
          searchId: null,
        });
      } else if (updateType === "loadSearch") {
        t.$emit("emitLoadSearch", false);
      } else if (updateType === "runSearch") {
        t.runSearchButtonDirty = true;
        t.$emit(
          "emitSearchPayload",
          this.compiledSearchOptionsArray,
          function (res) {
            console.log(res.length);
            if (t.searchResultCount === 0) {
              t.runSearchButtonDirty = false;
            }
          }
        );
      }
    },
    localZeroHour: function (datestring, late = false) {
      const t = this;
      let d = !Date.parse(datestring) ? t.todayDate() : datestring;
      return late
        ? new Date(d + "T23:59:59.999").toISOString()
        : new Date(d + "T00:00:00.000").toISOString();
    },
    validateSelectedFolders() {
      const t = this;
      t.searchOptions.selectedGroups = t.searchOptions.selectedGroups.filter(
        (x) => t.availablePrograms.indexOf(x) > -1
      );
    },
    iseven(index) {
      return index / 2 == 0;
    },
    reorder(index, down = false) {
      let a = this.searchOptions.fieldsToReturn;
      let newIndex = down ? index + 1 : index - 1;
      // console.log(newIndex);
      const movedItem = a.splice(index, 1)[0];
      a.splice(newIndex, 0, movedItem);
    },
    getLocal: function (callback) {
      var t = this;
      var authCheck = JSON.parse(window.localStorage.getItem("reportSettings"));
      if (authCheck) {
        for (let k in authCheck) {
          t.searchOptions[k] = authCheck[k];
        }
      }
      if (typeof callback === "function") {
        callback();
      }
    },
    saveLocal: function (callback) {
      var t = this;
      window.localStorage.setItem(
        "reportSettings",
        JSON.stringify(t.reportSettings)
      );
      if (typeof callback === "function") {
        console.log("saved setting");
        callback();
      }
    },
    getLocalLZ: function (callback) {
      var t = this;
      try {
        let localSettingLZ =
          window.localStorage.getItem(
            `reportSettings${t.clientBundle.logonData.UserID}`
          ) || window.localStorage.getItem("reportSettings");

        let localSettingJSON = LZ.decompressFromUTF16(localSettingLZ);
        let authCheck = JSON.parse(localSettingJSON);
        if (authCheck) {
          for (let k in authCheck) {
            t.searchOptions[k] = authCheck[k];
          }
        }
        if (typeof callback === "function") {
          callback();
        }
      } catch (e) {
        console.log(e);
        t.searchOptions = defaultSearchOptions(t.checkServerType());
      }
    },
    saveLocalLZ: function (callback) {
      var t = this;
      let reportSettingJSON = JSON.stringify(t.reportSettings);
      let reportSettingsLZ = LZ.compressToUTF16(reportSettingJSON);
      window.localStorage.setItem(
        `reportSettings${t.clientBundle.logonData.UserID}`,
        reportSettingsLZ
      );
      if (typeof callback === "function") {
        console.log("saved setting");
        callback();
      }
    },
    nomContentTypeSelections: function () {
      const t = this;
      return t.searchOptions.reportType === "ENPS"
        ? Object.keys(t.searchOptions.NOMContentTypes)
            .filter((x) => t.searchOptions.NOMContentTypes[x])
            .map((x) => `${x.replace("Newsgathering", "NG ")}`)
        : // .join(" or ")
          Object.keys(t.searchOptions.StorytellingTypes)
            .filter((x) => t.searchOptions.StorytellingTypes[x].selected)
            .map((x) => `"${x}"`);
      // .join(" OR ");
    },
    badgeName: function (f, limit = 4) {
      const t = this;
      try {
        if (["Date", "Time"].indexOf(f.fieldInfo.Validation) > -1) {
          return f.fieldValue === "default"
            ? `${t.todayDate()} to ${t.todayDate()}`
            : f.fieldValue
                .toString()
                .split(";")
                .map((x) => `${new Date(x).toLocaleDateString()}`)
                .join(" to ");
        } else if (["Duration", "Number"].includes(f.fieldInfo.Validation)) {
          // start and end are the same >> "exactly start"
          if (f.fieldValue.split("-")[0] === f.fieldValue.split("-")[1])
            return `exactly ${f.fieldValue.split("-")[1]}`;
          // if no end value >> or above
          else if (f.fieldValue.split("-")[1] >= "9999999")
            return `${f.fieldValue.split("-")[0]} or above`;
          else return f.fieldValue;
        } else if (Array.isArray(f.fieldValue) && f.fieldValue.length > limit) {
          return `One of ${f.fieldValue.length} selections`;
        } else if (f.fieldValue.toString().length > 0) {
          return `${
            !Array.isArray(f.fieldValue)
              ? `${f.fieldValue}${f.addBlank ? " or 'blank'" : ""}`
              : f.fieldValue
                  .map((c) =>
                    c.name
                      ? `'${c.name}'`
                      : `'${c.replace(`${t.notBlankSearchKey}`, "any value")}'`
                  )
                  .join(" or ")
          }`;
        } else if (f.fieldValue.toString().length === 0 && f.addBlank) {
          return "blank";
        } else return "";
      } catch (_) {
        return "";
      }
    },
    countGroupsByServer: function (_server) {
      const t = this;
      return t.clientBundle.gTables._Groups
        .filter((y) => y.Server === _server)
        .map((x) => x.ID)
        .filter((y) => t.searchOptions.selectedGroups.includes(y)).length;
    },
    checkFieldDateValues: function (field) {
      try {
        return new Date(field.fieldRangeEnd) < new Date(field.fieldRangeStart);
      } catch {
        return false;
      }
    },
    serversLabel: function (serverId) {
      const t = this;
      let r;
      try {
        r = t.clientBundle.gTables._Servers.filter(
          (p) => p.ServerID === serverId
        )[0].Description;
      } catch {
        r = serverId;
      }
      return r;
    },
    groupLabel: function (groupId, showServer = true) {
      const t = this;
      let r;
      try {
        let _group = t.clientBundle.gTables._Groups.filter(
          (p) => p.ID === groupId
        )[0];
        let _server = t.clientBundle.gTables._Servers.filter(
          (y) => y.ServerID === _group.Server
        )[0];
        r =
          _group.Description + (showServer ? ` [${_server.Description}]` : "");
      } catch {
        r = groupId;
      }
      return r;
    },
    fieldsToReturnLabel: function (f) {
      return `${f.DefaultCaption}  [${f.ID}]`;
    },
    setENPSContentDateRange(rangeName = "") {
      const t = this;
      let range = t.setBriefingDateRange({}, rangeName, true);
      t.searchOptions.searchDate.custom = rangeName;
      t.searchOptions.ItemDateTo = range.fieldRangeEnd;
      t.searchOptions.ItemDateFrom = range.fieldRangeStart;
    },
    setBriefingDateRange(field, rangeName = "", ret = false) {
      const t = this;
      if (rangeName === "month") {
        field.fieldRangeStart = t.monthStart();
        field.fieldRangeEnd = t.monthEnd();
      } else if (rangeName === "lastmonth") {
        field.fieldRangeStart = t.monthStart(-1);
        field.fieldRangeEnd = t.monthEnd(-1);
      } else if (rangeName === "week") {
        field.fieldRangeStart = t.lastSunday();
        field.fieldRangeEnd = t.nextSunday();
      } else if (rangeName === "lastweek") {
        field.fieldRangeStart = t.lastSunday(-7);
        field.fieldRangeEnd = t.lastSunday(-1);
      } else if (rangeName === "today" || field.fieldValue === "default") {
        field.fieldRangeStart = t.todayDate();
        field.fieldRangeEnd = t.todayDate();
        field.fieldRangeName = "today";
      }

      field.fieldValue = `${t.localZeroHour(
        field.fieldRangeStart
      )};${t.localZeroHour(field.fieldRangeEnd, true)}`;
      field.fieldRangeName = rangeName;
      if (ret) {
        return JSON.parse(JSON.stringify(field));
      }
    },
    unloadBriefingField: function (index, filterType) {
      const t = this;
      let fieldId =
        t.searchOptions.briefingFields[filterType][index].fieldInfo.ID;
      let returnFieldIndex = t.searchOptions.fieldsToReturn.findIndex(
        (x) => x.ID === fieldId
      );
      t.searchOptions.fieldsToReturn.splice(returnFieldIndex, 1);
      t.searchOptions.briefingFields[filterType].splice(index, 1);
      t.selectedBriefingFields[filterType].splice(index, 1);
    },
    resetSearchOptionsByFilterType: function () {
      const t = this;
      let ft = `${t.searchOptions.reportType === "ENPS" ? "ENPS" : "Playbook"}`;
      t.searchOptions = defaultSearchOptions(t.checkServerType());
      t.searchOptions.reportType = ft;
      t.selectedBriefingFields = { Required: [], Optional: [] };
      t.searchOptions.selectedServer = t.clientBundle.logonData.HomeDatabase;
      t.searchOptions.selectedGroups = [t.clientBundle.logonData.HomeProgram];
      t.selectedSavedSearch = null;
    },
    loadReturnField: function (f) {
      this.searchOptions.fieldsToReturn.push(f);
    },
    newFilterFieldObject(fieldInfo, value, range = "") {
      const t = this;
      let obj = {
        fieldInfo: { ...fieldInfo },
        fieldValue: value,
        fieldRangeName: "",
        addBlank: null,
        fieldRangeStart: "",
        fieldRangeEnd: "",
      };
      if (["week", "lastweek", "lastmonth", "month", "today"].includes(range))
        t.setBriefingDateRange(obj, range);
      if (range === "default") {
        obj.fieldRangeStart = t.todayDate();
        obj.fieldRangeEnd = t.todayDate();
      }
      return JSON.parse(JSON.stringify(obj));
    },
    loadBriefingField: function (f, filterType, defaultValue = "") {
      const t = this;
      //load briefingfields

      t.selectedBriefingFields[filterType.replace("multi-", "")].push(f);
      let v = defaultValue;
      let isTimeDate = ["Date", "Time"].includes(f.Validation);
      if (isTimeDate && !["week", "month", "today"].includes(v)) {
        //if time field with no range requested set default
        v = "default";
      } else if (f.Validation.toLowerCase() === "checkbox") {
        //checkbox default to true
        v = "true";
      } else if (
        ["staffidlist", "combobox", "checklist", "checkbox", "tree"].includes(
          f.Validation.toLowerCase()
        )
      ) {
        //if staff id default to empty array or array of defaultvalue
        v = defaultValue.length === 0 ? [] : [defaultValue].flat();
      }
      t.searchOptions.briefingFields[filterType.replace("multi-", "")].push(
        t.newFilterFieldObject(f, v, `${isTimeDate ? v : ""}`)
      );

      [f].forEach((e) => {
        if (
          t.searchOptions.fieldsToReturn.map((x) => x.ID).indexOf(e.ID) === -1
        ) {
          t.searchOptions.fieldsToReturn.push({
            ID: e.ID,
            DefaultCaption: e.DefaultCaption,
          });
        }
      });
    },
    monthStart: function (offset = 0) {
      var date = new Date(),
        y = date.getFullYear(),
        m = date.getMonth() + offset;
      var t = new Date(y, m, 1);
      return `${y}-${(t.getMonth() + 1).toString().padStart(2, "0")}-${t
        .getDate()
        .toString()
        .padStart(2, "0")}`;
      // return t.toISOString().split("T")[0];
    },
    monthEnd: function (offset = 0) {
      var date = new Date(),
        y = date.getFullYear(),
        m = date.getMonth() + offset;
      var t = new Date(y, m + 1, 0);
      return `${y}-${(t.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${t.getDate()}`;
      // return t.toISOString().split("T")[0];
    },
    lastSunday: function (offset = 0) {
      var t = new Date();
      t.setDate(t.getDate() - t.getDay() + offset);
      return t.toISOString().split("T")[0];
    },
    nextSunday: function () {
      var t = new Date();
      t.setDate(t.getDate() - t.getDay() + 6);
      return t.toISOString().split("T")[0];
    },
    todayDate: function () {
      var t = new Date();
      return t.toISOString().split("T")[0];
    },
    tomorrowDate: function () {
      var t = new Date();
      t.setDate(t.getDate() + 1);
      return t.toISOString().split("T")[0];
    },
    briefingFieldDateClassLabel: function (field, dateString) {
      return field.fieldRangeName === dateString ? "  font-weight: 900" : "";
    },
    ENPSContentDateClassLabel: function (dateString) {
      const t = this;
      return t.searchOptions.searchDate.custom === dateString &&
        t.searchOptions.searchDate.selected === "custom"
        ? "  font-weight: 900"
        : "";
    },
    selectedSearchChangeHandler: function (savedSearchObj) {
      const t = this;
      savedSearchObj.isPreset =
        savedSearchObj.isPreset == null ? false : savedSearchObj.isPreset;
      t.newSavedSearchName = "";
      Object.keys(savedSearchObj).forEach((x) => {
        t.searchOptions[x] = savedSearchObj[x];
      });
      //set time ranges for enps content named ranges
      if (t.searchOptions.searchDate.selected === "custom") {
        let fixDates = t.setBriefingDateRange(
          {},
          t.searchOptions.searchDate.custom,
          true
        );
        t.searchOptions.ItemDateFrom = fixDates.fieldRangeStart;
        t.searchOptions.ItemDateTo = fixDates.fieldRangeEnd;
      }
      //set time ranges for saved searches that have fieldvalues with time ranges week/month/year
      let timeRangeFields = ["Required", "Optional"]
        .map((x) => {
          return t.searchOptions.briefingFields[x].filter(
            (y) => y.fieldRangeName != ""
          );
        })
        .flat();
      if (timeRangeFields.length > 0) {
        //named range set to current week/month/day range
        timeRangeFields.forEach(
          (u) => (u = t.setBriefingDateRange(u, u.fieldRangeName))
        );
      }
      t.reloadAvailableSavedSearchesList();
    },
    handleNumberValues: function (field) {
      //initial value ""
      field.fieldValue = "";
      if (field.fieldRangeStart === "" && field.fieldRangeEnd > -1) {
        //no start but an end value >> 0-end
        field.fieldValue = `0-${field.fieldRangeEnd}`;
      } else if (field.fieldRangeStart > -1 && field.fieldRangeEnd === "") {
        // no end but a start >> start-9999999
        field.fieldValue = `${field.fieldRangeStart}-9999999`;
      } else if (
        field.fieldRangeStart > -1 &&
        field.fieldRangeEnd > -1 &&
        field.fieldRangeStart <= field.fieldRangeEnd
      ) {
        //start and end and start is <= end >> start-end
        field.fieldValue = `${field.fieldRangeStart}-${field.fieldRangeEnd}`;
      }
      //if somehow two empty strings got in there empty the whole thing
      if (["-", "0-", "-0"].includes(field.fieldValue)) field.fieldValue = "";

      // if (field.fieldRangeStart === "") {
      //   field.fieldValue = "";
      // } else if (field.fieldRangeStart === 0 && field.fieldRangeEnd === "") {
      //   field.fieldValue = "0-0";
      // } else if (field.fieldRangeStart <= field.fieldRangeEnd) {
      //   field.fieldValue = `${field.fieldRangeStart}-${field.fieldRangeEnd}`;
      // } else if (field.fieldRangeStart > -1) {
      //   field.fieldValue = `${field.fieldRangeStart}-${field.fieldRangeStart}`;
      // }
      // if (field.fieldValue === "-") field.fieldValue = "";
    },
    splitCaptionOnFilterText(filterStr, captionStr) {
      let targetIndex = captionStr
        .toLowerCase()
        .indexOf(filterStr.toLowerCase());
      return [
        captionStr.substr(0, targetIndex),
        captionStr.substr(targetIndex, filterStr.length),
        captionStr.substr(targetIndex + filterStr.length),
      ];
    },
  },
};
</script>

<style>
.location-card {
  max-width: 25rem;
  max-height: 250px;
}

.searchbar {
  background-color: #e9ecef;
}

.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}

.custom-control {
  z-index: 0;
}

.input-group-append {
  z-index: 0;
}

.list-group-item {
  z-index: 0;
}

/* .multiselect__option {
  z-index: 100;
}*/
.fieldselect {
  min-width: 325px;
}

.combocheck {
  z-index: 99999;
}

.card > .list-group {
  border-top: 0px;
  border-bottom: 0px;
}

.program-badge {
  margin-left: 3px;
  margin-bottom: 3px;
  z-index: 0;
}

.program-badge-x {
  color: white;
  z-index: 0;
}

/* 
#multi-Required {
  z-index: 599;
} */
</style>
